export default "__VITE_ASSET__RnRNu85y__"